import { useRouter } from 'next/router'
import { useMemo } from 'react'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import useToggleSdkContext from 'utils/useToogleSdk'
import { PenetapanNotAllowed } from 'api/kinerja/kepala-sekolah/config'

export default function usePenetapanGuard({
  throwErrorIfDisabled = false,
}: { throwErrorIfDisabled?: boolean } = {}) {
  const router = useRouter()
  const toggle = useToggleSdkContext()
  const { isCurrentPeriod } = usePeriodContext()

  const isPenetapanEnabled = useMemo(() => {
    const penetapanEnabled =
      toggle?.['kinerja-dinas-penetapan-enabled'] || false
    const isPenetapanCurrentPeriodEnabled =
      toggle?.['kinerja-dinas-penetapan-current-period-enabled'] || false

    // Return `false` if the current period is not enabled
    if (penetapanEnabled && isCurrentPeriod && !isPenetapanCurrentPeriodEnabled)
      return false

    return penetapanEnabled
  }, [isCurrentPeriod, toggle])

  if (!isPenetapanEnabled) {
    if (throwErrorIfDisabled) {
      throw new PenetapanNotAllowed(router.asPath, new Error('Unauthorized'))
    }

    return { isDisabled: true }
  }

  return { isDisabled: false }
}
